import './Content/Content'

import {SectionNavigationModule} from "./Content/System/Header/Header"
// import {FormValidate} from "~/components/Organisms/form/formValidate"
import {SliderModule, ExpertShuffle} from "./Content/Section/ExpertSlider/ExpertSlider"
import SlimSelect from "slim-select"
// import {VerticalAnimatedListModule} from "~/components/Molecules/verticalAnimatedList/verticalAnimatedList"
import {OfferNavigationModule} from "./Content/Offer/Menu";
import {SectionOfferModule} from "./Content/Section/Header/Home/Offer/Offer"
import {TextAnimationModule, VerticalAnimatedListModule} from "./Content/Section/Experience/Experience"
import {ModalModule} from "./Content/Team/Team";
import {SidebarMenuModule} from "./Content/InvestorRelations/Menu/Menu";
import {Accordion} from "./Content/Accordion/Accordion";

import {SectionObserver} from "./Content/Section/Section";

import {WebinarCounters} from "./Document/Page/Webinars/Featured/Featured";

import {CookieBox} from "./Content/CookieBox/CookieBox";

const sectionNavigationModule = new SectionNavigationModule;
// const formValidateModule = new FormValidate;

const verticalAnimatedListModule = new VerticalAnimatedListModule;
const sliderModule = new SliderModule;
// const verticalAnimatedListModule = new VerticalAnimatedListModule;

const sectionOfferModule = new SectionOfferModule;
const textAnimationModule = new TextAnimationModule;

const offerNavigationModule = new OfferNavigationModule;

const modalModule = new ModalModule();

const sidebarMenuModule = new SidebarMenuModule();

const accordion = new Accordion();

const sectionObserver = new SectionObserver();

const webinarCounters = new WebinarCounters();

const expertShuffle = new ExpertShuffle();
const cookieBox = new CookieBox();

cookieBox.init();
// setTimeout(() => {
    // @todo proper select initialization
    // const select = document.querySelector('#input-subject');
    sectionNavigationModule.init();
    // formValidateModule.init();
    verticalAnimatedListModule.init();
    sliderModule.init();
    offerNavigationModule.init();
    sidebarMenuModule.init();

    webinarCounters.init();

    setTimeout(() => {
        sectionOfferModule.init();
        modalModule.init();
        textAnimationModule.init();
    },100);



    // if (window.location.hash) {
    //     const bodyScrollTop = Math.abs(document.body.getBoundingClientRect().top);
    //     const nav = document.querySelector(".section--navigation") as HTMLElement;
    //     const navHeight = nav.offsetHeight;
    //     // console.log({
    //     //     scrollY: window.scrollY,
    //     //     rectTop: bodyScrollTop,
    //     //     navHeight: navHeight
    //     // })
    //     window.scrollTo(0, bodyScrollTop  -  navHeight);
    // }

    accordion.init();
    sectionObserver.init();

    const dropdowns = document.querySelectorAll('.dropdown');
    let prev: any = null;

    dropdowns.forEach(el => {

        el.addEventListener('click', () => {
            if(el.classList.contains('active')){
                el.classList.toggle('active');
            }else{
                if (prev) {
                    prev.classList.remove('active')
                }
                el.classList.toggle('active');
                prev = el;
            }

        })
    })


// }, 350)
